// ADMIN ACTION

const POST_ADMIN_DATA = "POST_ADMIN_DATA";
const POST_ADMIN_TOKEN = "POST_ADMIN_TOKEN";
const LOGOUT_ADMIN = "LOGOUT_ADMIN";

// NEW ACTION

// SUPPORT USER/DRIVER

const NEW_SUPPORT = "NEW_SUPPORT";

export { POST_ADMIN_DATA, POST_ADMIN_TOKEN, LOGOUT_ADMIN, NEW_SUPPORT };
